import { UserService } from './../../../../core/services/user-service.service';
import { AfterViewInit, Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { getCustomerByPermission, getFacilityByPermission, getForwarderByPermission, getTenantByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserService as UserDataService } from '../../services/user-service.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { User } from 'src/app/core/models/user.model';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { finalize } from 'rxjs/internal/operators/finalize';

@Component({
  selector: 'laas-user-modify',
  templateUrl: './user-modify.component.html',
  styleUrls: ['./user-modify.component.scss']
})
export class UserModifyComponent extends SessionBaseComponent implements OnInit, AfterViewInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.EditUser;
  userTypeOptions: any[];
  roleScopes: any[];
  roleOptions: any[];
  forwarderOptions: any[];
  facilityOptions: any[];
  tenantOptions: any[];
  customerOptions: any[];

  //save attribute
  userTypeSelected: string;
  email: string;
  userName: string;
  employCode: string;
  account: string;
  userId: string;
  isActivated: boolean;
  isExistUser: boolean;
  choose: any;
  user: BehaviorSubject<User>;

  constructor(
    injector: Injector,
    private userDataService: UserDataService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService
  ) {
    super(injector);
    //initial
    this.userTypeOptions = [];

    //save attribute
    this.userTypeSelected = "";
    this.email = "";
    this.userName = "";
    this.employCode = "";
    this.account = "";
    this.userId = "";
    this.isActivated = false;
    this.isExistUser = false;
    this.user = new BehaviorSubject<User>(this.userInfo);

    //current data
    if (this.routeStateService.getCurrent() != undefined) {
      var data = this.routeStateService.getCurrent().data;
      if (data != null) {
        this.userId = data.userId;
        this.isExistUser = true;
      }
    }

    this.facilityOptions = [];
    this.forwarderOptions = [];
    this.tenantOptions = [];
    this.customerOptions = [];
    this.roleOptions = [];
    this.roleScopes = [];

    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();
  }

  ngAfterViewInit(): void {

  }

  get userInfo(): User {
    const userData = this.localStorageService.getItem(GlobalConstants.currentUser);
    return isNullOrEmpty(userData) ? new User() : userData;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.loader.show();

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    //userType Options
    const keys = Object.keys(UserType);
    this.userTypeOptions = keys.filter(x => {
      return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
        this.userProfile.userType == x);
    }).map(o => {
      return {
        label: o,
        value: o
      }
    });
    this.translateService.get('Common.Message.ChooseOption')
      .subscribe({
        next: str => {
          this.userTypeOptions.unshift({
            label: str,
            value: ""
          });
        }
      });


    this.userDataService.getTenantOptions().subscribe({
      next: result => {
        this.tenantOptions = result.filter((x: any) => {
          return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getTenantByPermission(this.userProfile, this.permissionCode).includes(x.tenantCode));
        }).map((x: any) => {
          return {
            label: `${x.tenantCode} ${x.tenantName}`,
            value: x.tenantCode
          }
        });
        this.tenantOptions.unshift({
          label: "請選擇",
          value: ""
        });
      },
      complete: () => {

      }
    });

    this.userDataService.getForwarderOptions().subscribe({
      next: result => {
        this.forwarderOptions = result.filter((x: any) => {
          return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.value));
        }).map((x: any) => {
          return {
            label: `${x.value} ${x.text}`,
            value: x.value
          }
        });
        this.forwarderOptions.unshift({
          label: "請選擇",
          value: ""
        });
      },
      complete: () => {


      }
    });

    this.userDataService.getFacilityOptions().subscribe({
      next: result => {
        this.facilityOptions = result.filter((x: any) => {
          return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map((x: any) => {
          return {
            label: `${x.optionCode} ${x.optionDesc}`,
            value: x.optionCode
          }
        });
        this.facilityOptions.unshift({
          label: "請選擇",
          value: ""
        });
      },
      complete: () => {

      }
    });

    if (this.isExistUser) {
      this.userDataService.getUserScope(this.userId).subscribe({
        next: result => {
          this.account = result.account;
          this.email = result.email;
          this.userName = result.userName;
          this.employCode = result.employCode;
          this.isActivated = (result.isActivated == 1 ? true : false);
          this.userTypeSelected = result.userType;
          this.roleScopes = result.roleScopes;
          this.userTypeChange(null, false);
        }
      });
    }

    this.loader.hide();

    try {
      var customerServiceOptions = await this.userDataService.getCustomerOptions();

      this.customerOptions = customerServiceOptions.filter((x: any) => {
        return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
          getCustomerByPermission(this.userProfile, this.permissionCode).includes(x.customerCode));
      }).map((x: any) => {
        return {
          label: `${x.customerCode} ${x.customerName}`,
          value: x.customerCode
        }
      });

      this.customerOptions.unshift({
        label: "請選擇",
        value: ""
      });

    } catch (err) {
      console.log('get Customer Options Error');
    }



    // this.userService.getCustomerOptions().subscribe({
    //   next: result => {
    //     this.customerOptions = result.filter((x: any) => {
    //       return (this.userProfile.userType == UsereType.SuperAdmin.toString() ||
    //       getCustomerByPermission(this.userProfile, this.permissionCode).includes(x.customerCode));
    //     }).map((x: any) => {
    //       return {
    //         label: `${x.customerCode} ${x.customerName}`,
    //         value: x.customerCode
    //       }
    //     });
    //     this.customerOptions.unshift({
    //       label: "請選擇",
    //       value: ""
    //     });
    //   },
    //   complete: () => {

    //   }
    // });

  }

  addRoleScope(event: any): void {
    this.roleScopes.push({
      roleCode: "",
      tenants: [],
      shippings: [],
      forwarders: [],
      customers: []
    });
  }

  addTenentScope(event: any, roleScope: any): void {
    roleScope.tenants.push({
      tenantCode: null,
      orgId: null,
      dept: null,
      brand: null,
      customer: null
    });
  }

  addForwarderScope(event: any, roleScope: any): void {
    roleScope.forwarders.push({
      forwarderCode: null,
      tenantCode: null,
      facility: null,
    });
  }

  deleteTenantScope(event: any, roleScope: any, index: number): void {
    roleScope.tenants.splice(index, 1);
  }

  deleteForwarderScope(event: any, roleScope: any, index: number): void {
    roleScope.forwarders.splice(index, 1);
  }

  removeRoleScope(event: any, index: number): void {
    this.roleScopes.splice(index, 1);
  }

  hasRole(usereType: string): boolean {
    return this.userTypeSelected == usereType;
  }

  userTypeChange(event: any, isClearScope: boolean): void {
    if (!isNullOrEmpty(this.userTypeSelected)) {
      this.userDataService.getRoleOptions(this.userTypeSelected).subscribe({
        next: result => {
          this.roleOptions = result.map((x: any) => {
            return {
              label: x.roleName,
              value: x.roleCode
            };
          });

          this.translateService.get('Common.DropDown.Select')
            .subscribe({
              next: str => {
                this.roleOptions.unshift({
                  label: str,
                  value: ""
                });
              }
            });


          if (isClearScope) {
            this.roleScopes = [];
          }
        },
        complete: () => {

        }
      });
    }
  }

  saveRolesScopes(event: any): void {
    var saveObj: any = {
      account: this.account,
      userType: this.userTypeSelected,
      email: this.email,
      userName: this.userName,
      uuid: this.userId,
      roleScopes: this.roleScopes,
      isActivated: this.isActivated ? 1 : 0,
      employCode: this.employCode,
      currentUser: this.userInfo.userName
    };

    console.log('saveObj', saveObj);

    if (this.employCode?.length > 10) {
      this.toastService.warn(this.translateService.instant('UserMaintenance.Alert.EmployCodeExceeds'));
      return;
    }


    if (this.isExistUser) {
      this.loader.show();
      this.userDataService.updateUserScope(saveObj)
      .pipe(finalize(() => {
        this.loader.hide();
      }))
      .subscribe({
        next: result => {
          this.routeStateService.navigateTo('/User/userSearch');
        }
      });
    } else {

      let regex = /^[A-Za-z0-9!@._-]+$/;
      let hasInvalidCharacter = !(regex.test(saveObj.account) && regex.test(saveObj.email));
      if (hasInvalidCharacter) {
        this.toastService.error("帳號及信箱須為有效字符");
        return;
      }

      this.loader.show();
      this.userDataService.insertUserScope(saveObj)
      .pipe(finalize(() => {
        this.loader.hide();
      }))
      .subscribe({
        next: result => {
          this.routeStateService.navigateTo('/User/userSearch');
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
    }
  }

  resetBtn(evt: any): void {
    this.account = "";
    this.email = "";
    this.userName = "";
    if (!this.isExistUser) {
      this.userTypeSelected = "";
    }
    this.roleScopes = [];
    this.isActivated = false;
  }


  translationLabel() {
    this.choose = this.translateService.instant('Common.Message.ChooseOption');

  }

}
